.icon {
  position: relative;
  top: -2px !important;
  margin-right: 0.25rem !important;
}
